// "use client";

// import Link from "next/link";
// import { motion } from "motion/react";
// import Image from "next/image";
// import { Home, Compass, MapPin } from "lucide-react";

// export default function NotFound() {
//   return (
//     <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#fdfcfa] mt-[75px]">
//       {/* Background Image with Overlay */}
//       <div className="absolute inset-0 z-0">
//         <Image
//           src="https://images.unsplash.com/photo-1621213459146-c23d06b3e945?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1920"
//           alt="Serene Lake"
//           fill
//           className="object-cover"
//           priority
//         />
//         <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]" />
//       </div>

//       {/* Decorative Elements */}
//       <motion.div
//         initial={{ opacity: 0, scale: 0.8 }}
//         animate={{ opacity: 1, scale: 1 }}
//         transition={{ duration: 1.5, ease: "easeOut" }}
//         className="absolute inset-0 pointer-events-none z-10"
//       >
//         <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#5a6f3e]/10 rounded-full blur-3xl" />
//         <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#d4af37]/10 rounded-full blur-3xl" />
//       </motion.div>

//       {/* Content */}
//       <div className="relative z-20 text-center px-6 py-6 max-w-4xl mx-auto">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//         >
//           <p
//             className="text-[#d4af37] tracking-[0.4em] uppercase text-sm mb-6 font-medium"
//             style={{ fontFamily: "Jost, sans-serif" }}
//           >
//             A Moment of Stillness
//           </p>

//           <h1
//             className="text-8xl md:text-[12rem] text-white leading-none mb-8 opacity-90 select-none"
//             style={{
//               fontFamily: "Cormorant Garamond, serif",
//               fontWeight: 300,
//               fontStyle: "italic",
//             }}
//           >
//             404
//           </h1>

//           <p
//             className="text-white/80 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed"
//             style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
//           >
//             Even the most beautiful journeys have unexpected turns. It seems the
//             page you are looking for has drifted away like mist on Lake Bagela.
//           </p>

//           <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
//             <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
//               <Link
//                 href="/"
//                 className="flex items-center gap-3 bg-[#5a6f3e] text-white px-10 py-4 shadow-2xl hover:bg-[#4a5f2e] transition-all group min-w-[220px] justify-center"
//                 style={{ fontFamily: "Jost, sans-serif", fontWeight: 600 }}
//               >
//                 <Home className="w-5 h-5 group-hover:-translate-y-0.5 transition-transform" />
//                 Return to Resort
//               </Link>
//             </motion.div>

//             <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
//               <Link
//                 href="/rooms"
//                 className="flex items-center gap-3 bg-white/10 backdrop-blur-md text-white border border-white/30 px-10 py-4 hover:bg-white hover:text-[#2a2520] transition-all group min-w-[220px] justify-center"
//                 style={{ fontFamily: "Jost, sans-serif", fontWeight: 600 }}
//               >
//                 <Compass className="w-5 h-5 group-hover:rotate-12 transition-transform" />
//                 Explore Rooms
//               </Link>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>

//       {/* Floating Particles Animation */}
//       <div className="absolute inset-0 pointer-events-none opacity-20">
//         {[...Array(10)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute bg-white rounded-full"
//             style={{
//               width: Math.random() * 4 + 2 + "px",
//               height: Math.random() * 4 + 2 + "px",
//               top: Math.random() * 100 + "%",
//               left: Math.random() * 100 + "%",
//             }}
//             animate={{
//               y: [0, -100, 0],
//               opacity: [0, 1, 0],
//             }}
//             transition={{
//               duration: Math.random() * 10 + 10,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

"use client";

import Link from "next/link";
import { motion } from "motion/react";
import { Home, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden mt-[75px]">
      {/* Background — rich layered CSS scene, no external image dependency */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "linear-gradient(160deg, #0f1f3d 0%, #1a3a5c 35%, #0e4d3a 70%, #0a2e22 100%)",
        }}
      >
        {/* Stars layer */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(1px 1px at 10% 15%, rgba(255,255,255,0.8) 0%, transparent 100%),
            radial-gradient(1px 1px at 25% 8%, rgba(255,255,255,0.6) 0%, transparent 100%),
            radial-gradient(1.5px 1.5px at 40% 20%, rgba(255,255,255,0.9) 0%, transparent 100%),
            radial-gradient(1px 1px at 55% 5%, rgba(255,255,255,0.7) 0%, transparent 100%),
            radial-gradient(1px 1px at 70% 18%, rgba(255,255,255,0.5) 0%, transparent 100%),
            radial-gradient(1.5px 1.5px at 85% 10%, rgba(255,255,255,0.8) 0%, transparent 100%),
            radial-gradient(1px 1px at 92% 25%, rgba(255,255,255,0.6) 0%, transparent 100%),
            radial-gradient(1px 1px at 15% 35%, rgba(255,255,255,0.4) 0%, transparent 100%),
            radial-gradient(1px 1px at 60% 30%, rgba(255,255,255,0.5) 0%, transparent 100%),
            radial-gradient(1px 1px at 78% 40%, rgba(255,255,255,0.3) 0%, transparent 100%)`,
          }}
        />

        {/* Aurora / glow layers */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 80% 40% at 20% 60%, rgba(16,185,129,0.15) 0%, transparent 60%)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 60% 50% at 80% 70%, rgba(59,130,246,0.12) 0%, transparent 60%)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 50% 30% at 50% 20%, rgba(212,175,55,0.08) 0%, transparent 60%)",
          }}
        />

        {/* Mountain silhouettes */}
        <svg
          className="absolute bottom-0 w-full"
          viewBox="0 0 1440 400"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Back mountains */}
          <path
            d="M0 400 L0 280 L120 180 L240 240 L380 120 L520 200 L660 90 L800 180 L940 100 L1080 200 L1200 140 L1320 220 L1440 160 L1440 400 Z"
            fill="rgba(10,30,50,0.6)"
          />
          {/* Mid mountains */}
          <path
            d="M0 400 L0 320 L100 260 L200 310 L320 210 L440 280 L560 190 L680 260 L800 200 L920 270 L1040 220 L1160 290 L1280 240 L1440 300 L1440 400 Z"
            fill="rgba(8,25,40,0.75)"
          />
          {/* Snow caps */}
          <path
            d="M320 210 L360 235 L380 215 L400 240 L440 280"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M560 190 L590 215 L610 195 L640 225 L680 260"
            stroke="rgba(255,255,255,0.12)"
            strokeWidth="1.5"
            fill="none"
          />
          {/* Water reflection */}
          <path
            d="M0 360 L1440 360 L1440 400 L0 400 Z"
            fill="rgba(15,40,70,0.5)"
          />
          {/* Water shimmer lines */}
          <line
            x1="100"
            y1="375"
            x2="280"
            y2="375"
            stroke="rgba(255,255,255,0.06)"
            strokeWidth="1"
          />
          <line
            x1="400"
            y1="370"
            x2="600"
            y2="370"
            stroke="rgba(255,255,255,0.05)"
            strokeWidth="1"
          />
          <line
            x1="750"
            y1="380"
            x2="950"
            y2="380"
            stroke="rgba(255,255,255,0.07)"
            strokeWidth="1"
          />
          <line
            x1="1100"
            y1="372"
            x2="1350"
            y2="372"
            stroke="rgba(255,255,255,0.04)"
            strokeWidth="1"
          />
          {/* Moon reflection on water */}
          <ellipse
            cx="720"
            cy="385"
            rx="40"
            ry="4"
            fill="rgba(212,175,55,0.15)"
          />
        </svg>

        {/* Moon */}
        <div
          className="absolute"
          style={{ top: "8%", right: "15%", width: "64px", height: "64px" }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              background:
                "radial-gradient(circle at 40% 40%, #fff8dc, #f5d060)",
              boxShadow:
                "0 0 40px rgba(245,208,96,0.4), 0 0 80px rgba(245,208,96,0.15)",
            }}
          />
        </div>
      </div>

      {/* Floating particles */}
      <div className="absolute inset-0 pointer-events-none z-10">
        {[...Array(12)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-white"
            style={{
              width: `${(i % 3) + 1}px`,
              height: `${(i % 3) + 1}px`,
              top: `${(i * 17 + 5) % 80}%`,
              left: `${(i * 23 + 10) % 90}%`,
              opacity: 0.3,
            }}
            animate={{ y: [0, -80, 0], opacity: [0, 0.6, 0] }}
            transition={{
              duration: 8 + (i % 5) * 3,
              repeat: Infinity,
              delay: i * 1.2,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="relative z-20 text-center px-6 py-6 max-w-3xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          {/* Eyebrow */}
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.1em" }}
            animate={{ opacity: 1, letterSpacing: "0.4em" }}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="text-amber-300 uppercase text-xs mb-8 font-medium tracking-[0.4em]"
            style={{ fontFamily: "Jost, sans-serif" }}
          >
            A Moment of Stillness
          </motion.p>

          {/* 404 */}
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.1, ease: "easeOut" }}
            className="relative inline-block mb-6"
          >
            <h1
              className="text-[9rem] md:text-[14rem] leading-none select-none"
              style={{
                fontFamily: "Cormorant Garamond, serif",
                fontWeight: 300,
                fontStyle: "italic",
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(212,175,55,0.7) 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                filter: "drop-shadow(0 4px 24px rgba(212,175,55,0.25))",
              }}
            >
              404
            </h1>
            {/* Glow behind number */}
            <div
              className="absolute inset-0 -z-10"
              style={{
                background:
                  "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(212,175,55,0.12) 0%, transparent 70%)",
              }}
            />
          </motion.div>

          {/* Divider line */}
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mx-auto mb-8"
            style={{
              width: "120px",
              height: "1px",
              background:
                "linear-gradient(90deg, transparent, rgba(212,175,55,0.7), transparent)",
            }}
          />

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-white/70 text-base md:text-lg mb-12 max-w-xl mx-auto leading-relaxed"
            style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
          >
            The trail ends here. The page you're searching for has wandered off
            the map — perhaps swept away by mountain mist.
          </motion.p>

          {/* Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
              <Link
                href="/"
                className="flex items-center gap-3 px-10 py-4 text-white font-semibold min-w-[220px] justify-center transition-all group"
                style={{
                  fontFamily: "Jost, sans-serif",
                  background: "linear-gradient(135deg, #5a6f3e, #3d5229)",
                  border: "1px solid rgba(90,111,62,0.6)",
                  boxShadow: "0 4px 24px rgba(90,111,62,0.3)",
                }}
              >
                <Home className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" />
                Return Home
              </Link>
            </motion.div>

            <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
              <Link
                href="/rooms"
                className="flex items-center gap-3 px-10 py-4 text-white/90 font-semibold min-w-[220px] justify-center transition-all group hover:text-white"
                style={{
                  fontFamily: "Jost, sans-serif",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  backdropFilter: "blur(12px)",
                }}
              >
                <Compass className="w-4 h-4 group-hover:rotate-45 transition-transform duration-500" />
                Explore Rooms
              </Link>
            </motion.div>
          </motion.div>

          {/* Bottom hint */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.2 }}
            className="mt-12 text-white/30 text-xs tracking-widest uppercase"
            style={{ fontFamily: "Jost, sans-serif" }}
          >
            Error 404 &nbsp;·&nbsp; Page not found
          </motion.p>
        </motion.div>
      </div>
    </div>
  );
}
